import React from 'react'

import './Scrim.css'

const Scrim = ({ visible, clearSelectedPainting }) => (
  visible && <div className="Scrim-container" onClick={clearSelectedPainting} />
)

export default Scrim
